export function canCreateTagChildren(tagClassActions, tagActionsMap, parentTag, allowRootCreation) {
    if (!tagClassActions) {
        return false;
    }
    if (!parentTag && !allowRootCreation) {
        return false;
    }
    if (tagClassActions.canCreate) {
        if (parentTag) {
            var parentActions = tagActionsMap[parentTag.id];
            return parentActions ? parentActions.canUpdate || parentActions.isOwner : false;
        }
        else if (allowRootCreation) {
            return tagClassActions.canCreate;
        }
    }
    return false;
}
export function calculateTagPerms(tagClassActions, tagActionsMap, tag) {
    var _a, _b, _c;
    var canCreate = (_a = tagClassActions === null || tagClassActions === void 0 ? void 0 : tagClassActions.canCreate) !== null && _a !== void 0 ? _a : false;
    var canEdit = (_b = tagClassActions === null || tagClassActions === void 0 ? void 0 : tagClassActions.canUpdate) !== null && _b !== void 0 ? _b : false;
    var canDelete = (_c = tagClassActions === null || tagClassActions === void 0 ? void 0 : tagClassActions.canDeleteById) !== null && _c !== void 0 ? _c : false;
    if (!tag) {
        return { canCreate: canCreate, canEdit: canEdit, canDelete: canDelete };
    }
    var targetActions = tag.id ? tagActionsMap[tag.id] : undefined;
    if (targetActions) {
        canEdit = canEdit && (targetActions.canUpdate || targetActions.isOwner);
    }
    if (targetActions) {
        canDelete = canDelete && (targetActions.canDelete || targetActions.isOwner);
    }
    return { canCreate: canCreate, canEdit: canEdit, canDelete: canDelete };
}
